const getSector = (initiative, sectors) => {
    let sectorName = '<not set>';

    initiative?.impact?.find((impact) => {
        if (!impact?.subsector) return false;

        const subsectorObj = sectors?.find(
            (s) => s._id === impact.subsector
        );
        const name = subsectorObj?.sector?.sectorName;
        if (
            name === 'Agriculture' ||
            name === 'Manufacturing' ||
            name === 'Domestic trade & service' ||
            name === 'Construction, Machinery &Working Fund' ||
            name === 'Hotel & tourism' ||
            name === 'Export' ||
            name === 'Import' ||
            name === 'Mining' ||
            name === 'Real Estate' ||
            name === 'Transport'
        ) {
            sectorName = name;
            return true; // stop searching (same pattern as getFrequencyAndDirection)
        }

        return false;
    });

    return sectorName;
};

export default getSector;  